"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _Col = _interopRequireDefault(require("../Col"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * The props for the Field component.
 */

const generateHelpText = _ref => {
  let {
    help,
    helpId,
    helpClassName,
    isTickElement
  } = _ref;
  return help ? /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)("p-form-help-text", helpClassName, {
      "is-tick-element": isTickElement
    }),
    id: helpId
  }, help) : null;
};
const generateError = (error, caution, success, validationId) => {
  if (!error && !caution && !success) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "p-form-validation__message",
    id: validationId
  }, error || caution || success);
};
const generateLabel = (forId, required, label, labelClassName, stacked) => {
  if (!label) {
    return null;
  }
  const labelNode = /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: labelClassName,
    forId: forId,
    required: required
  }, label);
  if (stacked) {
    return /*#__PURE__*/_react.default.createElement(_Col.default, {
      size: 4
    }, labelNode);
  }
  return labelNode;
};
const generateContent = _ref2 => {
  let {
    isSelect,
    children,
    labelFirst,
    labelNode,
    help,
    helpClassName,
    error,
    caution,
    success,
    validationId,
    helpId,
    isTickElement
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "p-form__control u-clearfix"
  }, isSelect ? /*#__PURE__*/_react.default.createElement("div", {
    className: "p-form-validation__select-wrapper"
  }, children) : children, !labelFirst && labelNode, generateHelpText({
    helpId,
    help,
    helpClassName,
    isTickElement
  }), generateError(error, caution, success, validationId));
};
const Field = _ref3 => {
  let {
    caution,
    children,
    className,
    error,
    forId,
    help,
    helpClassName,
    helpId,
    isSelect,
    isTickElement,
    label,
    labelClassName,
    labelFirst = true,
    required,
    stacked,
    success,
    validationId,
    ...props
  } = _ref3;
  const labelNode = generateLabel(forId, required, label, labelClassName, stacked);
  const content = generateContent({
    isSelect,
    isTickElement,
    children,
    labelFirst,
    labelNode,
    help,
    helpClassName,
    error,
    caution,
    success,
    validationId,
    helpId
  });
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("p-form__group", "p-form-validation", className, {
      "is-error": error,
      "is-caution": caution,
      "is-success": success,
      row: stacked
    })
  }, props), labelFirst && labelNode, stacked ? /*#__PURE__*/_react.default.createElement(_Col.default, {
    size: 8
  }, content) : content);
};
var _default = exports.default = Field;